import React, {useRef, useState} from 'react'
import UnderLineInput from '../../../../components/input/UnderLineInput'
import WizButton from '../../../../components/button/WizButton'
import useNavigation from '../../../../hooks/useNavigation'
import DeletePostModal from './DeletePostModal'
import WizSelectButton from '../../../../components/button/WizSelectButton'

interface IProps {
    className?: string
    onClick?: (e: string) => void
    onChangeSearchTarget?: (e: string) => void
    onClickAllBanUser?: () => void
    search?: string
    searchTarget?: string
    checkList?: string[]
    searchList?: {id: string; value: string}[]
}

const PostSearchContainer: React.FC<IProps> = ({
    className,
    onClick,
    search,
    checkList,
    onClickAllBanUser,
    onChangeSearchTarget,
    searchList,
    searchTarget,
}) => {
    const [inputText, setInputText] = useState('')
    const {goPostCreate} = useNavigation()

    const postDeleteModalRef = useRef<any>()
    return (
        <>
            <div className={'flex justify-between items-center md:flex-col md:gap-y-[50px]'}>
                <div className={'flex items-center space-x-[10px]'}>
                    <WizButton text={'New Post'} className={'text-white'} type={'primary'} onClick={goPostCreate} />

                    <WizButton
                        text={'Ban User All Check'}
                        type={'red'}
                        className={'bg-[#E56E73]'}
                        onClick={() => onClickAllBanUser()}
                    />

                    {checkList?.length > 0 && (
                        <WizButton
                            text={'Delete All'}
                            type={'red'}
                            onClick={() => postDeleteModalRef?.current?.show()}
                        />
                    )}
                </div>
                <div className={`flex gap-[10px] w-full justify-end ${className}`}>
                    <WizSelectButton
                        onChange={e => onChangeSearchTarget(e.id)}
                        data={searchList}
                        activeValue={searchList?.find(item => item?.id === searchTarget)}
                    />
                    <UnderLineInput
                        type={'text'}
                        inputClassName={'h-full'}
                        value={search || inputText}
                        onChanged={(e: string) => setInputText(e)}
                        onEnterKeyPress={() => onClick(inputText)}
                    />
                    <WizButton
                        text={'Search'}
                        size={'small'}
                        onClick={() => {
                            onClick(inputText)
                        }}
                    />
                    <WizButton
                        text={'Reset'}
                        className={'text-white sm:hidden'}
                        type={'blue'}
                        size={'small'}
                        onClick={() => {
                            onClick('')
                            setInputText('')
                        }}
                    />
                </div>
            </div>
            <DeletePostModal deleteList={checkList} ref={postDeleteModalRef} />
        </>
    )
}

export default PostSearchContainer
